<template>
  <div class="pdp-sticky-cta-pricing">
    <div
      v-if="isLoading"
      :class="[
        'skeleton-container',
        {
          '-is-vip': isVip(),
        },
      ]"
    >
      <v-skeleton-loader
        type="heading"
        width="250"
      ></v-skeleton-loader>
      <template v-if="!isVip()">
        <v-skeleton-loader
          type="text"
          width="10%"
          class="mt-2"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="text"
          width="80%"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="text"
          width="40%"
        ></v-skeleton-loader>
      </template>
    </div>
    <template v-else>
      <div class="main-pricing">฿{{ mainPricing | currency }}</div>
      <div v-if="!isVip()">
        <div class="label-or">
          หรือ
        </div>
        <div class="headline-s">
          ฿{{ (mainPricing / INSTALLMENT.MAX) | currency }} / เดือน
          ผ่อน 0% นานสูงสุด {{ INSTALLMENT.MAX }} เดือน
        </div>
        <v-btn
          :color="isBnn ? '#eba614' : 'primary'"
          :ripple="false"
          plain
          width="fit-content"
          height="fit-content"
          class="btn-link"
          @click="$emit('openPaymentMethod')"
        >
          ดูเพิ่มเติมเกี่ยวกับการผ่อนชำระ
          <v-icon>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { INSTALLMENT } from '@/config/index'
import isBnn from '@/config/isBnn'

export default {
  name: 'PDPPricing',
  inject: ['isVip'],
  data() {
    return {
      INSTALLMENT,
      isBnn,
    }
  },
  computed: {
    ...mapState({
      pricing: state => state.cart.cartSummaryData,
      isLoading: state => state.cart.isLoading,
    }),

    mainPricing() {
      return this.pricing?.main_product_price ?? 0
    },
  },
}
</script>

<style lang="stylus" scoped>
.skeleton-container {
    min-height: 96.78px;

	@media screen and (min-width: 768px) {
    	min-height: 116.78px;
	}

	@media screen and (min-width: 1280px) {
    	min-height: 96.78px;
	}

    &.-is-vip {
		min-height: 30px;
	}
}
.pdp-sticky-cta-pricing {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    grid-gap: .5rem;
    gap: 8px;

    .main-pricing {
        font-family: "SF Pro Text";
        font-size: 1.75rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.875rem;
        letter-spacing: .03rem;
    }

    .label-or {
        font-family: "SF Pro Text";
        font-size: .75rem;
        font-style: normal;
        font-weight: 400;
        line-height: .875rem;
        color: #6e6e73;
    }

    .btn-link {
        padding 0 !important
    }
}
</style>
